// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.event-form[data-v-3503c3a8] {\n  background: #f2f2f2;\n  vertical-align: top;\n  border-top: 1px solid #dee2e6;\n  padding:10px 15px;\n}\n.actions[data-v-3503c3a8] {\n  text-align: right;\n  padding: 5px 0;\n}\n.cancel-btn[data-v-3503c3a8] {\n  margin-right: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
